import { ApiCall } from '../helper/axios';
const BASE = '/api/meta-ad-audit';
const metaAdAuditService = {
    listReports(params = {}, token) {
        return ApiCall('GET', `${BASE}/reports`, params, { Authorization: token || '' });
    },
    listClientsWithReports(token) {
        return ApiCall('GET', `${BASE}/reports/clients-with-reports`, '', { Authorization: token || '' });
    },
    getReportById(reportId, token) {
        return ApiCall('GET', `${BASE}/reports/${reportId}`, '', { Authorization: token || '' });
    },
    createReport(payload, token) {
        return ApiCall('POST', `${BASE}/reports`, payload, { Authorization: token || '' });
    },
    updateReport(reportId, payload, token) {
        return ApiCall('PUT', `${BASE}/reports/${reportId}`, payload, { Authorization: token || '' });
    },
    refreshReport(reportId, token) {
        return ApiCall('POST', `${BASE}/reports/${reportId}/refresh`, {}, { Authorization: token || '' });
    },
    deleteReport(reportId, token) {
        return ApiCall('DELETE', `${BASE}/reports/${reportId}`, '', { Authorization: token || '' });
    },
    getJobStatus(reportId, token) {
        return ApiCall('GET', `${BASE}/reports/${reportId}/job`, '', { Authorization: token || '' });
    },
    // Shared endpoint used for the Add Report client dropdown.
    // Filters by module-key = meta_ad_audit (auto-injected), which maps
    // to ["meta"] via MODULE_NETWORK_MAP — so only clients with an
    // active meta connection appear.
    getVisibleClients(token) {
        return ApiCall('GET', '/api/visible-clients', '', { Authorization: token || '' });
    },
    generateDeck(reportId, token, regenerate = false) {
        const suffix = regenerate ? '?regenerate=true' : '';
        return ApiCall('POST', `${BASE}/reports/${reportId}/deck${suffix}`, {}, { Authorization: token || '' });
    },
    downloadDeck(reportId, token) {
        return ApiCall('GET', `${BASE}/reports/${reportId}/deck/download`, '', { Authorization: token || '' }, 7 * 60 * 1000, // existing default
        'blob' // ← critical: tells axios to return a Blob
        );
    },
    // ── Custom benchmarks (Batch 8) ────────────────────────────────────────
    // Used by the "Custom Benchmark" drawer on the detail page.
    /** GET — returns both `missing` and `all` window lists for the drawer. */
    getBenchmarkWindows(reportId, token) {
        return ApiCall('GET', `${BASE}/reports/${reportId}/benchmark-windows`, '', { Authorization: token || '' });
    },
    /** PUT — replace the report's custom benchmarks and re-run the audit. */
    saveCustomBenchmarks(reportId, payload, token) {
        return ApiCall('PUT', `${BASE}/reports/${reportId}/custom-benchmarks`, payload, { Authorization: token || '' });
    },
};
export default metaAdAuditService;
